/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import {
  ListAgentConnectionBlocksResult,
  ListAgentConnectionBlocksResult$inboundSchema,
} from "../components/listagentconnectionblocksresult.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListAgentConnectionBlocksSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ListAgentConnectionBlocksRequest = {
  /**
   * Cursor for the next page of blocks.
   */
  cursor?: string | undefined;
  /**
   * The number of blocks to return per page.
   */
  limit?: number | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

export type ListAgentConnectionBlocksResponse = {
  result: ListAgentConnectionBlocksResult;
};

/** @internal */
export type ListAgentConnectionBlocksSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListAgentConnectionBlocksSecurity$outboundSchema: z.ZodMiniType<
  ListAgentConnectionBlocksSecurity$Outbound,
  ListAgentConnectionBlocksSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listAgentConnectionBlocksSecurityToJSON(
  listAgentConnectionBlocksSecurity: ListAgentConnectionBlocksSecurity,
): string {
  return JSON.stringify(
    ListAgentConnectionBlocksSecurity$outboundSchema.parse(
      listAgentConnectionBlocksSecurity,
    ),
  );
}

/** @internal */
export type ListAgentConnectionBlocksRequest$Outbound = {
  cursor?: string | undefined;
  limit: number;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListAgentConnectionBlocksRequest$outboundSchema: z.ZodMiniType<
  ListAgentConnectionBlocksRequest$Outbound,
  ListAgentConnectionBlocksRequest
> = z.pipe(
  z.object({
    cursor: z.optional(z.string()),
    limit: z._default(z.int(), 50),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function listAgentConnectionBlocksRequestToJSON(
  listAgentConnectionBlocksRequest: ListAgentConnectionBlocksRequest,
): string {
  return JSON.stringify(
    ListAgentConnectionBlocksRequest$outboundSchema.parse(
      listAgentConnectionBlocksRequest,
    ),
  );
}

/** @internal */
export const ListAgentConnectionBlocksResponse$inboundSchema: z.ZodMiniType<
  ListAgentConnectionBlocksResponse,
  unknown
> = z.pipe(
  z.object({
    Result: ListAgentConnectionBlocksResult$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "Result": "result",
    });
  }),
);

export function listAgentConnectionBlocksResponseFromJSON(
  jsonString: string,
): SafeParseResult<ListAgentConnectionBlocksResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListAgentConnectionBlocksResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListAgentConnectionBlocksResponse' from JSON`,
  );
}
